import React, { useEffect, useRef, useState } from 'react'
import { book } from '../assets/data/constants';
import IconComponent from './Icon';
import { FiX } from 'react-icons/fi';
import { FaChevronDown } from 'react-icons/fa';
import axiosInstance from '../api/apiClient';
import axios from 'axios';

type EditBookProps = {
    setEditBook: (book: boolean) => void;
    book: book;
  };

const EditBook: React.FC<EditBookProps> = ({ setEditBook, book }) => {
    const [editedBook, setEditedBook] = useState<book>(book);
    const [series, setSeries] = useState<any[]>([]);

    const [selectedGenres, setSelectedGenres] = useState<any[]>(book['Genres'] || []);
    const [genreIsOpen, setGenreIsOpen] = useState(false);

    const [genres, setGenres] = useState<any[]>(book['Genres'] || []);

    const genreRef = useRef<HTMLDivElement>(null);

    const toggleSelection = (genre: { genre_id: string; name: string }) => {
        if (selectedGenres.includes(genre.genre_id)) {
            setSelectedGenres(selectedGenres.filter((g) => g !== genre.genre_id));
        } else {
            setSelectedGenres([...selectedGenres, genre.genre_id.toString()]);
        }
    };

    const removeGenre = (genre: string) => {
        setSelectedGenres(selectedGenres.filter((g) => g !== genre));
    };

    const getSeries = async () => {
        const response: any = await axiosInstance.get('/getAllSeries');
        setSeries(response);
    }

    const getGenres = async () => {
        const response: any = await axiosInstance.get('/getAllGenres');
        const formatResponse = response.map((genre: { genre_id: number; name: string; }) => {
            return {
                genre_id: genre.genre_id.toString(),
                name: genre.name
            }
        }).sort((a: { name: string; }, b: { name: string; }) => a.name.localeCompare(b.name));
        setGenres(formatResponse);
    }

    useEffect(() => {
        getSeries();
        getGenres();
    }, []);

    useEffect(() => {
    const handleClickOutside = (event:any) => {
        if (genreRef.current && !genreRef.current.contains(event.target)) {
            setGenreIsOpen(false);
        }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
}, []);

    const requestEditBook = async (editedBook: book, bookId: string) => {
        const updatedBook = {
            "my_rating": editedBook['My Rating'],
            // "number_of_pages": editedBook['Number of Pages'],
            "pages_read": editedBook['Pages Read'] || null,
            "date_read": editedBook['Date Read'] === '' ? null : editedBook['Date Read'],
            // "date_added": editedBook['Date Added'],
            "exclusive_shelf": editedBook['Exclusive Shelf'],
            "my_review": editedBook['My Review'],
            "read_count": editedBook['Read Count'],
            "owned_copies": editedBook['Owned Copies'],
            // "cover_url": editedBook['Cover URL'],
            // "serie_id": editedBook['Serie Id'],
            // "serie_position": editedBook['Serie Position'],
            // "genres": selectedGenres
        };

        await axiosInstance.post(`/updateBook/${bookId}`, updatedBook);
        setEditBook(false);
    }

    return (
        <div className="bg-white rounded-3xl shadow-lg p-4 min-h-20 mt-[40px]">
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    requestEditBook(editedBook, book['Book Id'].toString());
                }}
                id="editBookForm"
            >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label
                            htmlFor="Number of Pages"
                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                        >
                            Number of Pages
                        </label>
                        <input
                            value={editedBook['Number of Pages']}
                            // TODO: admin only
                            onChange={(e) => setEditedBook({...editedBook, 'Number of Pages': parseInt(e.target.value)})}
                            type="number"
                            id="Number of Pages"
                            className="cursor-not-allowed bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            placeholder="Number of Pages"
                            disabled
                            required
                        />
                    </div>

                           <div>
                        <label className="block mb-2 text-sm font-medium text-gray-900 mt-2">Genres</label>
                        <div className="relative" ref={genreRef}>
                            <div
                                className="flex cursor-not-allowed items-center border border-gray-300 text-gray-900 bg-[#F9FAFB] text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                // TODO: admin only
                                // onClick={() => setGenreIsOpen(!genreIsOpen)}
                            >
                                {selectedGenres.length === 0 && (
                                    <span className="text-gray-400">Select genre...</span>
                                )}
                                <div className='gap-2 flex'>
                                    {selectedGenres.map((genre) => (
                                        <span
                                            key={genre}
                                            className="flex items-center bg-[#8784D8] text-white text-sm px-2 py-1 rounded-full"
                                        >
                                            {genres.find((g) => g.genre_id === genre.toString())?.name}
                                            <IconComponent 
                                                icon={FiX}
                                                onClick={() => {
                                                    // TODO: admin only
                                                    // removeGenre(genre);
                                                }}
                                                color={'white'}
                                                className="w-4 h-4 ml-1 cursor-pointer"
                                            />
                                        </span>
                                    ))}
                                </div>
                                <IconComponent width={"1em"} icon={FaChevronDown} className="text-gray-500 ml-auto text-xs" />
                            </div>

                            {genreIsOpen && (
                                <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                                    {genres.map((genre) => (
                                    <li
                                        key={genre.genre_id}
                                        className={`px-4 py-2 cursor-pointer hover:bg-indigo-100 ${
                                        selectedGenres.includes(genre.genre_id) ? 'bg-[#8784D8] text-white' : ''
                                        }`}
                                        onClick={() => toggleSelection(genre)}
                                    >
                                        {genre.name}
                                    </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                    
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label
                            htmlFor="Pages Read"
                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                        >
                            Pages Read
                        </label>
                        <input
                            value={editedBook['Pages Read'] || ''}
                            onChange={(e) => setEditedBook({...editedBook, 'Pages Read': parseInt(e.target.value) || null})}
                            type="number"
                            id="Pages Read"
                            className="disabled:bg-gray-50 disabled:cursor-not-allowed border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            placeholder="Pages Read"
                        />
                    </div>

                    <div>
                        <label
                            htmlFor="Date Read"
                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                        >
                            Date Read
                        </label>
                        <input
                                value={
                                editedBook['Date Read']
                                    ? new Date(editedBook['Date Read']).toISOString().slice(0, 10)
                                    : ''
                                }
                            onChange={(e) => setEditedBook({...editedBook, 'Date Read': e.target.value})}
                            type="date"
                            id="Date Read"
                            className="appearance-none border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            placeholder="Date Read"
                        />
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                    <div>
                        <label
                            htmlFor="Read Count"
                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                        >
                            Read Count
                        </label>
                        <input
                                value={editedBook['Read Count']}
                            onChange={(e) => setEditedBook({...editedBook, 'Read Count': parseInt(e.target.value)})}
                            type="number"
                            id="Read Count"
                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            placeholder="Read Count"
                            required
                        />
                    </div>

                    <div>
                        <label
                            htmlFor="Owned Copies"
                            className="block mb-2 text-sm font-medium text-gray-900 mt-2"
                        >
                            Owned Copies
                        </label>
                        <input
                            value={editedBook['Owned Copies']}
                            onChange={(e) => setEditedBook({...editedBook, 'Owned Copies': parseInt(e.target.value)})}
                            type="number"
                            id="Owned Copies"
                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            placeholder="Owned Copies"
                            required
                        />
                    </div>
             
                </div>
                
                <div className="mt-6">
                    <button
                    type="submit"
                    className="disabled:text-gray-900/50 disabled:bg-gray-50 disabled:cursor-not-allowed disabled:hover:bg-gray-50 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
                    >
                    Update book
                    </button>
                </div>
            </form>
        </div>
    )

    
}

export default EditBook